<template>
  <div class="title">
    <div class="title-text">{{ moduleNameAndLength }}</div>
    <div class="title-btns">
      <kye-button type="text" class="batch-btn" @click="handleBatch" v-if="!isBatchFlag">
        <img src="../../../images/module.svg" />
        批量管理
      </kye-button>
      <template v-if="isBatchFlag">
        <kye-button type="text" @click="handleBatchMove">
          <img src="../../../images/tag-move.svg" />
          批量移动
        </kye-button>
        <kye-button type="text" @click="handleBatchDelete">
          <img src="../../../images/tag-del.svg" />
          批量移除
        </kye-button>
        <kye-button type="text" @click="handleBatchCancel">
          <img src="../../../images/tag-cancel.svg" />
          取消
        </kye-button>
      </template>
    </div>
    <div class="title-tips">可选择多个批量移动分组</div>
  </div>
</template>

<script>
export default {
  name: 'ModuleListTitle',
  props: {
    moduleNameAndLength: {
      type: String,
      default: ''
    },
    isBatchFlag: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleBatch() {
      this.$emit('batch')
    },
    handleBatchMove() {
      this.$emit('batch-move')
    },
    handleBatchDelete() {
      this.$emit('batch-delete')
    },
    handleBatchCancel() {
      this.$emit('batch-cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  position: absolute;
  left: 223px;
  display: flex;
  align-items: center;
  top: 16px;
  &-text {
    color: rgba(69, 60, 90, 1);
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
  }
  .title-btns {
    margin-left: 12px;
    display: flex;
    gap: 12px;
    /deep/ .el-button--text + .el-button--text {
      margin-left: 0;
    }
    /deep/ .el-button{
      padding: 0 8px;
      height: 28px;
      display: flex;
      align-items: center;
      border-radius: 8px;
      border: 1px solid rgba(224, 223, 239, 1);
      >span{
        display: flex;
        align-items: center;
        >img{
          margin-right: 3px;
        }
      }
    }
  }
  &-tips {
    color: #68607B;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-left: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/module-list/module-list-title.vue